import React from 'react';
import { CreatePriceListModal } from './CreatePriceListModal';

export const PricingModals: React.FC = () => {
  return (
    <>
      <CreatePriceListModal />
    </>
  );
};

// Export individual modals
export { CreatePriceListModal }; 